module.exports = __webpack_public_path__ + "img/sigefHome.01574afa.png";